module.exports = __webpack_public_path__ + "static/media/1011985.26d9c3f4.png";